import { filterObjectValues } from 'helpers/filter'

import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs'

import api from '../api'
import { GetMplusListResponse, GetMplusParams, MplusObject } from './types'

export const mplusApi = api.injectEndpoints({
  endpoints: build => ({
    getMplus: build.query<GetMplusListResponse, GetMplusParams>({
      query: params => ({
        url: `/web/mplus_murabaha/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    getMplusById: build.query<MplusObject, MplusObject['id']>({
      query: id => ({
        url: `/web/mplus_murabaha/${id}/`,
      }),
    }),
    mplusStatistics: build.query<Array<IStatistic>, GetMplusParams>({
      query: params => ({
        url: `/web/mplus_murabaha/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    downloadMplusExcel: build.mutation<void, GetMplusParams>({
      query: params => ({
        url: `/web/mplus_murabaha/excel_report/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
